import {DomUtil, Layer, SVG} from 'leaflet';

export class CSVG extends SVG {

  getStyle() {
    const style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
    style.innerHTML = '.track-polyline{marker: url(#track-dot-marker);}';
    return style;
  }

  getMarker(color, lineWeight, opacity) {
    const weight = lineWeight * 0.33;
    // const bounds = Math.ceil(weight * 2);
    // viewBox="0 0 10 10"

    const el = document.createElementNS('http://www.w3.org/2000/svg', 'marker');
    el.setAttribute('id', 'track-dot-marker');
    el.setAttribute('refX', weight.toString());
    el.setAttribute('refY', weight.toString());
    // el.setAttribute('fill', color);
    el.setAttribute('markerWidth', (weight * 2).toString(10));
    el.setAttribute('markerHeight', (weight * 2).toString(10));
    const cr = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    cr.setAttribute('cx', weight.toString());
    cr.setAttribute('cy', weight.toString());
    cr.setAttribute('r', weight.toString());
    cr.setAttribute('fill', color);
    el.appendChild(cr);

    return el;

    // return document.createElement(
    //     '<marker id="track-dot-marker" refX="'+bounds+'" refY="'+bounds+'"' +
    //     'markerWidth="'+bounds+'" markerHeight="'+bounds+'">' +
    //     // '<circle cx="'+bounds+'" cy="'+bounds+'" r="'+bounds+'" fill="'+color+'" />' +
    //     '</marker>'
    // );
  }

  _initPath(layer: Layer) {
    // @ts-ignore
    super._initPath(layer);
    // @ts-ignore
    const path = layer._path;
    DomUtil.addClass(path, 'custom-svg');

    // @ts-ignore
    // this._rootGroup.appendChild(this.getStyle());
    // @ts-ignore
    this._rootGroup.appendChild(this.getMarker(layer.options.color, layer.options.weight));
  }
}
